export default "__VITE_ASSET__fceaad45__"